export default __webpack_public_path__ + "static/media/cover_20230904.c7644669.jpg";